"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _Modal = require("@insided/shared/uikit/Modal");

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

function normalizeRoles(roles, onRoleChange) {
  return roles === null || roles === void 0 ? void 0 : roles.map(function (role) {
    return {
      title: role.name,
      value: String(role.id),
      onClick: function onClick() {
        return onRoleChange(role);
      },
      'data-qa': "invite-member-role-".concat(role.name.toLowerCase().split(' ').join('-'))
    };
  });
}

var InviteUserModal = function InviteUserModal(_ref) {
  var _errors$email;

  var isOpen = _ref.isOpen,
      roles = _ref.roles,
      inviteeEmail = _ref.inviteeEmail,
      selectedRole = _ref.selectedRole,
      onClose = _ref.onClose,
      onInviteUser = _ref.onInviteUser,
      onEmailChange = _ref.onEmailChange,
      onRoleChange = _ref.onRoleChange,
      errors = _ref.errors;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: isOpen,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Invite member",
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
    className: "invite-member-modal"
  }, (0, _preact.h)(_InputGroup.default, {
    value: inviteeEmail !== null && inviteeEmail !== void 0 ? inviteeEmail : undefined,
    title: "Email address",
    type: "email",
    placeholder: "Invite someone ...",
    onChange: function onChange(e) {
      return onEmailChange(e.target.value);
    },
    error: (_errors$email = errors.email) !== null && _errors$email !== void 0 ? _errors$email : undefined
  }), (0, _preact.h)("div", null, (0, _preact.h)("label", null, "Role"), (0, _preact.h)(_DropdownControl.default, {
    align: "adjust" // @ts-expect-error
    ,
    items: normalizeRoles(roles, onRoleChange),
    trigger: (0, _preact.h)(_buttonControl.default, {
      icon: "arrowDropdown",
      title: selectedRole === null || selectedRole === void 0 ? void 0 : selectedRole.name,
      class: "invite-member-role-dropdown qa-invite-member-role-dropdown"
    })
  })))), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
    title: "Send invite via email",
    variant: "primary",
    onClick: onInviteUser,
    class: "qa-invite-user"
  }), (0, _preact.h)(_buttonControl.default, {
    title: "Cancel",
    onClick: function onClick() {
      return onClose();
    }
  })));
};

var _default = InviteUserModal;
exports.default = _default;